require("babel-polyfill");

require('font-awesome-webpack');
require("angular");
require("node_modules/angular-i18n/angular-locale_nb-no.js");
require("angular-animate");
require('angular-material/angular-material.js');
require('node_modules/angular-material/angular-material.min.css');
require('angular-aria');
require('angular-messages');
require('node_modules/angular-material-data-table/dist/md-data-table.min.css');
require('node_modules/angular-material-data-table/dist/md-data-table.min.js');
require('angular-ui-router');
require('angular-resource');
require('src/style/main.less');

require('src/vendor/mdPickers/mdPickers.js');
require('src/vendor/mdPickers/mdPickers.less');

require('src/vendor/angular-material-sidenav/angular-material-sidenav.js');
require('src/vendor/angular-material-sidenav/angular-material-sidenav.less');

require("./rkcApp.ts");
require("./colorConfig.ts");
require("./stateConfig.ts");

function requireAll(r) { r.keys().forEach(r); }
requireAll(require.context('./components/', true, /\.ts$/));
requireAll(require.context('./services/', true, /\.ts$/));


/** WEBPACK FOOTER **
 ** ./src/app/app.ts
 **/